import { Checkbox, FormControlLabel } from "@mui/material";
import { purple } from "@mui/material/colors";
import React from "react";
import { CloseButton, Col, Row } from "react-bootstrap";
import PortalModal from "../../Portals/PortalModal.jsx";
import {
  ButtonDownloadExcel,
  FormCard,
  Hr,
  SectionWrapper,
  TextTitleList,
} from "./ModalDownloadAnswersSurvey.styled.js";

const ModalDownloadAnswersSurvey = ({
  closeModal,
  handleDownloadExcel,
  labelOfButton,
  selectedCheckbox,
  setSelectedCheckbox,
}) => {
  return (
    <PortalModal>
      <FormCard>
        <Row className="d-flex justify-content-around">
          <Col md="6">
            <TextTitleList className="font-weight-bold mx-2 my-2">
              Report fields selection
            </TextTitleList>
          </Col>
          <Col md="6" className="d-flex justify-content-end align-items-center">
            <CloseButton onClick={() => closeModal()}></CloseButton>
          </Col>
        </Row>
        <Row className="mx-2 mt-2">
          <Hr className="mt-0" />
          <Col md="12">
            <p>Please select all the fields you want for your report</p>
          </Col>
          <Col md="6">
            <FormControlLabel
              control={
                <Checkbox
                  defaultChecked={selectedCheckbox.surveyName}
                  sx={{
                    color: purple[400],
                    "&.Mui-checked": {
                      color: purple[400],
                    },
                  }}
                  onClick={() =>
                    setSelectedCheckbox({
                      surveyName: !selectedCheckbox.surveyName,
                      user: selectedCheckbox.user,
                      client: selectedCheckbox.client,
                      country: selectedCheckbox.country,
                      city: selectedCheckbox.city,
                      role: selectedCheckbox.role,
                      lob: selectedCheckbox.lob,
                      tpid: selectedCheckbox.tpid,
                      username: selectedCheckbox.username,
                      answerDate: selectedCheckbox.answerDate,
                      activationDate: selectedCheckbox.activationDate,
                      userStatus: selectedCheckbox.userStatus,
                    })
                  }
                />
              }
              label="Survey Name"
            />
          </Col>
          <Col md="6">
            <FormControlLabel
              control={
                <Checkbox
                  defaultChecked={selectedCheckbox.tpid}
                  sx={{
                    color: purple[400],
                    "&.Mui-checked": {
                      color: purple[400],
                    },
                  }}
                  onClick={() =>
                    setSelectedCheckbox({
                      surveyName: selectedCheckbox.surveyName,
                      user: selectedCheckbox.user,
                      client: selectedCheckbox.client,
                      country: selectedCheckbox.country,
                      city: selectedCheckbox.city,
                      role: selectedCheckbox.role,
                      lob: selectedCheckbox.lob,
                      tpid: !selectedCheckbox.tpid,
                      username: selectedCheckbox.username,
                      answerDate: selectedCheckbox.answerDate,
                      activationDate: selectedCheckbox.activationDate,
                      userStatus: selectedCheckbox.userStatus,
                    })
                  }
                />
              }
              label="TP Id"
            />
          </Col>
          <Col md="6">
            <FormControlLabel
              control={
                <Checkbox
                  defaultChecked={selectedCheckbox.user}
                  sx={{
                    color: purple[400],
                    "&.Mui-checked": {
                      color: purple[400],
                    },
                  }}
                  onClick={() =>
                    setSelectedCheckbox({
                      surveyName: selectedCheckbox.surveyName,
                      user: !selectedCheckbox.user,
                      client: selectedCheckbox.client,
                      country: selectedCheckbox.country,
                      city: selectedCheckbox.city,
                      role: selectedCheckbox.role,
                      lob: selectedCheckbox.lob,
                      tpid: selectedCheckbox.tpid,
                      username: selectedCheckbox.username,
                      answerDate: selectedCheckbox.answerDate,
                      activationDate: selectedCheckbox.activationDate,
                      userStatus: selectedCheckbox.userStatus,
                    })
                  }
                />
              }
              label="User (First and last name)"
            />
          </Col>
          <Col md="6">
            <FormControlLabel
              control={
                <Checkbox
                  defaultChecked={selectedCheckbox.username}
                  sx={{
                    color: purple[400],
                    "&.Mui-checked": {
                      color: purple[400],
                    },
                  }}
                  onClick={() =>
                    setSelectedCheckbox({
                      surveyName: selectedCheckbox.surveyName,
                      user: selectedCheckbox.user,
                      client: selectedCheckbox.client,
                      country: selectedCheckbox.country,
                      city: selectedCheckbox.city,
                      role: selectedCheckbox.role,
                      lob: selectedCheckbox.lob,
                      tpid: selectedCheckbox.tpid,
                      username: !selectedCheckbox.username,
                      answerDate: selectedCheckbox.answerDate,
                      activationDate: selectedCheckbox.activationDate,
                      userStatus: selectedCheckbox.userStatus,
                    })
                  }
                />
              }
              label="Username"
            />
          </Col>
          <Col md="6">
            <FormControlLabel
              control={
                <Checkbox
                  defaultChecked={selectedCheckbox.client}
                  sx={{
                    color: purple[400],
                    "&.Mui-checked": {
                      color: purple[400],
                    },
                  }}
                  onClick={() =>
                    setSelectedCheckbox({
                      surveyName: selectedCheckbox.surveyName,
                      user: selectedCheckbox.user,
                      client: !selectedCheckbox.client,
                      country: selectedCheckbox.country,
                      city: selectedCheckbox.city,
                      role: selectedCheckbox.role,
                      lob: selectedCheckbox.lob,
                      tpid: selectedCheckbox.tpid,
                      username: selectedCheckbox.username,
                      answerDate: selectedCheckbox.answerDate,
                      activationDate: selectedCheckbox.activationDate,
                      userStatus: selectedCheckbox.userStatus,
                    })
                  }
                />
              }
              label="Client"
            />
          </Col>
          <Col md="6">
            <FormControlLabel
              control={
                <Checkbox
                  defaultChecked={selectedCheckbox.answerDate}
                  sx={{
                    color: purple[400],
                    "&.Mui-checked": {
                      color: purple[400],
                    },
                  }}
                  onClick={() =>
                    setSelectedCheckbox({
                      surveyName: selectedCheckbox.surveyName,
                      user: selectedCheckbox.user,
                      client: selectedCheckbox.client,
                      country: selectedCheckbox.country,
                      city: selectedCheckbox.city,
                      role: selectedCheckbox.role,
                      lob: selectedCheckbox.lob,
                      tpid: selectedCheckbox.tpid,
                      username: selectedCheckbox.username,
                      answerDate: !selectedCheckbox.answerDate,
                      activationDate: selectedCheckbox.activationDate,
                      userStatus: selectedCheckbox.userStatus,
                    })
                  }
                />
              }
              label="Answer date"
            />
          </Col>
          <Col md="6">
            <FormControlLabel
              control={
                <Checkbox
                  defaultChecked={selectedCheckbox.country}
                  sx={{
                    color: purple[400],
                    "&.Mui-checked": {
                      color: purple[400],
                    },
                  }}
                  onClick={() =>
                    setSelectedCheckbox({
                      surveyName: selectedCheckbox.surveyName,
                      user: selectedCheckbox.user,
                      client: selectedCheckbox.client,
                      country: !selectedCheckbox.country,
                      city: selectedCheckbox.city,
                      role: selectedCheckbox.role,
                      lob: selectedCheckbox.lob,
                      tpid: selectedCheckbox.tpid,
                      username: selectedCheckbox.username,
                      answerDate: selectedCheckbox.answerDate,
                      activationDate: selectedCheckbox.activationDate,
                      userStatus: selectedCheckbox.userStatus,
                    })
                  }
                />
              }
              label="Country"
            />
          </Col>
          <Col md="6">
            <FormControlLabel
              control={
                <Checkbox
                  defaultChecked={selectedCheckbox.activationDate}
                  sx={{
                    color: purple[400],
                    "&.Mui-checked": {
                      color: purple[400],
                    },
                  }}
                  onClick={() =>
                    setSelectedCheckbox({
                      surveyName: selectedCheckbox.surveyName,
                      user: selectedCheckbox.user,
                      client: selectedCheckbox.client,
                      country: selectedCheckbox.country,
                      city: selectedCheckbox.city,
                      role: selectedCheckbox.role,
                      lob: selectedCheckbox.lob,
                      tpid: selectedCheckbox.tpid,
                      username: selectedCheckbox.username,
                      answerDate: selectedCheckbox.answerDate,
                      activationDate: !selectedCheckbox.activationDate,
                      userStatus: selectedCheckbox.userStatus,
                    })
                  }
                />
              }
              label="Activation date"
            />
          </Col>
          <Col md="6">
            <FormControlLabel
              control={
                <Checkbox
                  defaultChecked={selectedCheckbox.city}
                  sx={{
                    color: purple[400],
                    "&.Mui-checked": {
                      color: purple[400],
                    },
                  }}
                  onClick={() =>
                    setSelectedCheckbox({
                      surveyName: selectedCheckbox.surveyName,
                      user: selectedCheckbox.user,
                      client: selectedCheckbox.client,
                      country: selectedCheckbox.country,
                      city: !selectedCheckbox.city,
                      role: selectedCheckbox.role,
                      lob: selectedCheckbox.lob,
                      tpid: selectedCheckbox.tpid,
                      username: selectedCheckbox.username,
                      answerDate: selectedCheckbox.answerDate,
                      activationDate: selectedCheckbox.activationDate,
                      userStatus: selectedCheckbox.userStatus,
                    })
                  }
                />
              }
              label="City"
            />
          </Col>
          <Col md="6">
            <FormControlLabel
              control={
                <Checkbox
                  defaultChecked={selectedCheckbox.userStatus}
                  sx={{
                    color: purple[400],
                    "&.Mui-checked": {
                      color: purple[400],
                    },
                  }}
                  onClick={() =>
                    setSelectedCheckbox({
                      surveyName: selectedCheckbox.surveyName,
                      user: selectedCheckbox.user,
                      client: selectedCheckbox.client,
                      country: selectedCheckbox.country,
                      city: selectedCheckbox.city,
                      role: selectedCheckbox.role,
                      lob: selectedCheckbox.lob,
                      tpid: selectedCheckbox.tpid,
                      username: selectedCheckbox.username,
                      answerDate: selectedCheckbox.answerDate,
                      activationDate: selectedCheckbox.activationDate,
                      userStatus: !selectedCheckbox.userStatus,
                    })
                  }
                />
              }
              label="User Status"
            />
          </Col>
          <Col md="6">
            <FormControlLabel
              control={
                <Checkbox
                  defaultChecked={selectedCheckbox.lob}
                  sx={{
                    color: purple[400],
                    "&.Mui-checked": {
                      color: purple[400],
                    },
                  }}
                  onClick={() =>
                    setSelectedCheckbox({
                      surveyName: selectedCheckbox.surveyName,
                      user: selectedCheckbox.user,
                      client: selectedCheckbox.client,
                      country: selectedCheckbox.country,
                      city: selectedCheckbox.city,
                      role: selectedCheckbox.role,
                      lob: !selectedCheckbox.lob,
                      tpid: selectedCheckbox.tpid,
                      username: selectedCheckbox.username,
                      answerDate: selectedCheckbox.answerDate,
                      activationDate: selectedCheckbox.activationDate,
                      userStatus: selectedCheckbox.userStatus,
                    })
                  }
                />
              }
              label="Lob"
            />
          </Col>
          <Col md="6">
            <FormControlLabel
              control={
                <Checkbox
                  defaultChecked={selectedCheckbox.role}
                  sx={{
                    color: purple[400],
                    "&.Mui-checked": {
                      color: purple[400],
                    },
                  }}
                  onClick={() =>
                    setSelectedCheckbox({
                      surveyName: selectedCheckbox.surveyName,
                      user: selectedCheckbox.user,
                      client: selectedCheckbox.client,
                      country: selectedCheckbox.country,
                      city: selectedCheckbox.city,
                      role: !selectedCheckbox.role,
                      lob: selectedCheckbox.lob,
                      tpid: selectedCheckbox.tpid,
                      username: selectedCheckbox.username,
                      answerDate: selectedCheckbox.answerDate,
                      activationDate: selectedCheckbox.activationDate,
                      userStatus: selectedCheckbox.userStatus,
                    })
                  }
                />
              }
              label="Role"
            />
          </Col>
          <Hr className="mt-0" />
        </Row>

        <Row className="d-flex justify-content-around">
          <Col md="12" className="my-3">
            <SectionWrapper>
              <Row className="d-flex justify-content-center">
                <Col md="4">
                  <ButtonDownloadExcel onClick={() => handleDownloadExcel()}>
                    {`${labelOfButton}`}
                  </ButtonDownloadExcel>
                </Col>
              </Row>
            </SectionWrapper>
          </Col>
        </Row>
      </FormCard>
    </PortalModal>
  );
};

export default ModalDownloadAnswersSurvey;
